module.exports = __webpack_public_path__ + "img/labmem_text_title_jp.6e04974e.png";